import hadithsData from '../data/hadiths.json';

export const fetchHadiths = async () => {
    // Return the hadiths array from the local JSON file
    return hadithsData.hadiths;
};
